const emptyDoc = (paragraphText = '') => ({
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: paragraphText ? [{ type: 'text', text: paragraphText }] : undefined,
    },
  ],
})

const headingDoc = (text = '', level = 2) => ({
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: { level },
      content: text ? [{ type: 'text', text }] : undefined,
    },
  ],
})

const listDoc = (ordered = false, items = ['']) => ({
  type: 'doc',
  content: [
    {
      type: ordered ? 'orderedList' : 'bulletList',
      content: items.map((item) => ({
        type: 'listItem',
        content: [
          {
            type: 'paragraph',
            content: item ? [{ type: 'text', text: item }] : undefined,
          },
        ],
      })),
    },
  ],
})

const quoteDoc = (text = '') => ({
  type: 'doc',
  content: [
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          content: text ? [{ type: 'text', text }] : undefined,
        },
      ],
    },
  ],
})

export const createBlockId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `b_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
}

export const createAnchorId = (blockId) =>
  `h-${String(blockId || createBlockId()).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 24)}`

export const BLOCK_TYPE_OPTIONS = [
  // Текст / структура
  { type: 'heading', label: 'Заголовок', icon: 'heading', iconWeight: 'regular' },
  { type: 'paragraph', label: 'Текст', icon: 'font', iconWeight: 'regular' },
  { type: 'blockquote', label: 'Цитата', icon: 'quote-left', iconWeight: 'regular' },
  { type: 'bulletList', label: 'Маркований список', icon: 'list-ul', iconWeight: 'regular' },
  { type: 'orderedList', label: 'Нумерований список', icon: 'list-ol', iconWeight: 'regular' },
  // Медіа
  { type: 'image', label: 'Зображення', icon: 'image', iconWeight: 'regular' },
  { type: 'gallery', label: 'Галерея', icon: 'images', iconWeight: 'regular' },
  { type: 'beforeAfter', label: 'До / Після', icon: 'columns', iconWeight: 'regular' },
  { type: 'imageText', label: 'Зображення + текст', icon: 'newspaper', iconWeight: 'regular' },
  { type: 'youtube', label: 'YouTube', icon: 'youtube', iconWeight: 'brand' },
  { type: 'videoUpload', label: 'Відео', icon: 'video', iconWeight: 'regular' },
  // Комерція / CTA
  { type: 'productSet', label: 'Товари', icon: 'shopping-bag', iconWeight: 'regular' },
  { type: 'ameButton', label: 'Кнопка Ame', icon: 'external-link', iconWeight: 'regular' },
]

export const createEmptyBlock = (type = 'paragraph') => {
  const id = createBlockId()
  switch (type) {
    case 'heading':
      return { id, type, level: 2, content: headingDoc('', 2), anchorId: createAnchorId(id) }
    case 'blockquote':
      return { id, type, content: quoteDoc('') }
    case 'bulletList':
      return { id, type, content: listDoc(false, ['']) }
    case 'orderedList':
      return { id, type, content: listDoc(true, ['']) }
    case 'image':
      return { id, type, photo: null, caption: '', alt: '', href: '', openInNewTab: false }
    case 'gallery':
      return { id, type, layout: 'grid', items: [] }
    case 'beforeAfter':
      return {
        id,
        type,
        before: { photo: null, caption: '', alt: 'До' },
        after: { photo: null, caption: '', alt: 'Після' },
      }
    case 'imageText':
      return {
        id,
        type,
        photo: null,
        alt: '',
        caption: '',
        href: '',
        openInNewTab: false,
        content: emptyDoc(''),
        imagePosition: 'left',
      }
    case 'youtube':
      return { id, type, url: '', videoId: '' }
    case 'videoUpload':
      return { id, type, video: null, poster: null, caption: '' }
    case 'productSet':
      return { id, type, title: '', productRefs: [] }
    case 'ameButton':
      return { id, type, label: '', href: '', openInNewTab: true }
    case 'paragraph':
    default:
      return { id, type: 'paragraph', content: emptyDoc('') }
  }
}

export const TEXT_BLOCK_TYPES = new Set([
  'paragraph',
  'heading',
  'blockquote',
  'bulletList',
  'orderedList',
])

export const isTextBlock = (block) => TEXT_BLOCK_TYPES.has(block?.type)
